(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvTagSelector', drvTagSelector);

    drvTagSelector.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvTagSelector
     *
     * @description
     * A component used for selecting an tags from the supplied list of tags.
     *
     * # Scope Params
     * {string} label - The label/name to be shown for the control. Optional.
     * {object} ngModel - The selected value.
     * {array} tags - List of tags which will be shown by the select control
     * {bool} disabled - Disables the control. Optional.
     * {bool} ngRequired - Value must be selected. Optional.
     */
    function drvTagSelector() {
        var directive = {
            restrict: 'E',
            controller: drvTagSelectorCtrl,
            controllerAs: 'drvCtrl',
            scope: {},
            bindToController: {
                label: '@?',
                value: '=ngModel',
                tags: '<',
                disabled: '<?',
                ngRequired: '<?'
            },
            template:
                '<drv-selector value="drvCtrl.value"' +
                '              items="drvCtrl.tags"' +
                '              label="{{drvCtrl.label}}"' +
                '              ng-required="drvCtrl.ngRequired"' +
                '              multiple="true"' +
                '              disabled="drvCtrl.disabled">' +
                '   <selected-template>' +
                '       {{item.Name}}' +
                '   </selected-template>' +
                '   <dropdown-item-template>' +
                '       {{item.Name}}' +
                '       <md-divider></md-divider>' +
                '   </dropdown-item-template>' +
                '</drv-selector>'
        };

        drvTagSelectorCtrl.$inject = [];

        return directive;

        function drvTagSelectorCtrl() {
            /* jshint validthis:true */
            var drvCtrl = this;

            activate();

            function activate() {

            }
        }
    }
})();